<script lang="ts">
  import { _ } from 'svelte-i18n';
  /* eslint-disable @typescript-eslint/no-explicit-any */
  export let items: { key: string; text: string }[] = [];
</script>

{#if items.length}
  <ul class="space-y-3">
    {#each items as t}
      <li class="flex gap-3 text-sm"><span class="mt-1.5 inline-block w-2 h-2 rounded-full bg-teal-600 shrink-0" /><span>{t.text}</span></li>
    {/each}
  </ul>
{:else}
  <p class="text-sm text-zinc-500">{$_('report.takeaways.none')}</p>
{/if}
